module.exports = __webpack_public_path__ + "static/media/walking.73800011.gif";